/// <summary name='cafm.url' type='Object'>CAFM URL container object</summary>
cafm.url = {

    get: function (relUrl, params) {
        /// <summary>Gets an absolute virtual path</summary>
        /// <param name="relUrl" type="String">The app relative path</param>
        /// <param name="params" type="Array">An optional parameter or array of parameters for a formatted URL string</param>
        /// <returns type="String">Returns the absolute virtual path</returns>

        if (relUrl && relUrl.indexOf('/') == 0) {
            relUrl = relUrl.substring(1);
        }
        else if (relUrl && relUrl.indexOf('~/') == 0) {
            relUrl = relUrl.substring(2);
        }
        var url = cafm.url.getFullPath(relUrl);
        var urlFinal = !params ? url : url.format(params);

        var sessionTimeZone = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);

        if (sessionTimeZone === null && urlFinal === '/') {
            cafm.url.set('/timezone/changetimezone');
        } 

        return urlFinal;
    },
    set: function (url, params) {
        /// <summary>Navigates the browser to the app relative path</summary>
        /// <param name="url" type="String">The app relative path</param>
        /// <param name="params" type="Array">An optional parameter or array of parameters for a formatted URL string</param>

        if (url && url.indexOf('/') == 0) {
            url = url.substring(1);
        }
        else if (url && url.indexOf('~/') == 0) {
            url = url.substring(2);
        }
        else if (!url) {
            url = '';
        }        
        var url = cafm.url.getFullPath(url);
        window.location = !params ? url : url.format(params);
    },
    api: function (relUrl, params) {
        /// <summary>Gets an absolute virtual web api path</summary>
        /// <param name="relUrl" type="String">The app relative path</param>
        /// <param name="params" type="Array">An optional parameter or array of parameters for a formatted URL string</param>
        /// <returns type="String">Returns the absolute virtual web api path</returns>

        if (relUrl && relUrl.indexOf('/') == 0) {
            relUrl = relUrl.substring(1);
        }
        else if (relUrl && relUrl.indexOf('~/') == 0) {
            relUrl = relUrl.substring(2);
        }
        var url = cafm.url.getFullPath(relUrl, true);
        return !params ? url : url.format(params);
    },
    /**
     * Gets an absolute URL
     * @param {String} path The URL path
     * @param {Boolean} useLocationBaseUrl Optional flag to determine using settings host URL or the current location 
     * @return {String} The absolute URL
     */
    abs(path, useLocationBaseUrl) {
        if (path && path.indexOf('/') == 0) {
            path = path.substring(1);
        }
        else if (path && path.indexOf('~/') == 0) {
            path = path.substring(2);
        }
        let baseUrl = useLocationBaseUrl ? cafm.url.currentOrigin() : cafm.getClientSettings().hostUrl;
        return (baseUrl == '/' ? '' : baseUrl) + cafm.url.getFullPath(path);
    },
    /**
     * Gets an absolute API URL
     * @param {String} path The API URL path
     * @param {Boolean} useLocationBaseUrl Optional flag to determine using settings host URL or the current location 
     * @return {String} The absolute API URL
     */
    absApi(path, useLocationBaseUrl) {
        if (path && path.indexOf('/') == 0) {
            path = path.substring(1);
        }
        else if (path && path.indexOf('~/') == 0) {
            path = path.substring(2);
        }
        let baseUrl = useLocationBaseUrl ? cafm.url.currentOrigin() : cafm.getClientSettings().hostUrl;
        return (baseUrl == '/' ? '' : baseUrl) + cafm.url.getFullPath(path, true);
    },
    current: function(){
        
        return window.location.pathname;
    },
    /**
     * Gets the current URL origin
     * @return {String} The current URL origin
     */
    currentOrigin() {
        return `${window.location.protocol}//${window.location.host}`
    },
    hash: function (hash) {

        if (hash) {

            window.location.hash = hash;
        }
        else {

            return window.location.hash;
        }
    },
    isSetup: function(){

        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get(cafm.res.consts.Url_SetupPath));
    },
    isError: function () {
        
        return cafm.url.current().toLowerCase().indexOf(cafm.url.get('/error/')) === 0;
    },
    isPageNotFound: function(){

        return $('#pageNotFound').length;
    },
    isLogin: function(){
        
        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get(cafm.auth.loginPath));
    },
    isChangePassword: function(){

        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get(cafm.res.consts.Url_ChangePassword));
    },
    isForgottenPassword: function () {

        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get(cafm.res.consts.Url_ForgottenPassword));
    },
    isBrowserInfo: function () {

        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get(cafm.res.consts.Url_BrowserInfo));
    },
    isPublicRoomBookerPage: function() {

        return cafm.url.urlsEqual(cafm.url.current(), cafm.url.get('~/roombooking/public'))
    },
    isLocal: function (url) {
        /// <summary>Determines if a URL is local or not</summary>
        /// <param name="url" type="String">The URL to test</param>
        /// <returns type="Boolean">Returns true if the URL is local</returns>

        return url.indexOf(cafm.getClientSettings().hostUrl) == 0;
    },
    isAuthenticatedUrl: function() {

        return !(cafm.url.isSetup() || cafm.url.isError() || cafm.url.isPageNotFound() || cafm.url.isBrowserInfo() || cafm.url.isLogin() || cafm.url.isForgottenPassword() || cafm.url.isPublicRoomBookerPage());
    },
    urlsEqual: function (url1, url2) {

        return cafm.util.trimEnd(url1, '/').toLowerCase() == cafm.util.trimEnd(url2, '/').toLowerCase();
    },
    getFullPath: function (path, isApi) {
        /// <summary>Get a full path, ensures base URL and lower case path.</summary>
        /// <param name="path" type="String">The URL path, can include query string.</param>
        /// <param name="isApi" type="Boolean">API URL flag, defaults to non-API.</param>
        /// <returns type="String">Returns resolved full path</returns>

        // ensure a string for path
        path = (path || '');
        
        var query, hash, i;
        // check for query, if there is one separate it and keep it
        if ((i = path.indexOf('?')) > -1) {
            query = path.substring(i);
            path = path.substring(0, i);
        }
        // check for hash, if there is one separate it and keep it
        if ((i = path.indexOf('#')) > -1) {
            hash = path.substring(i);
            path = path.substring(0, i);
        }

        // ensure lower case path
        path = path.toLowerCase();
        // append the URL query
        if (query) path += query;
        // append the URL hash 
        if (hash) path += hash;
        // get applicable base path
        var burl = isApi ? cafm.getClientSettings().baseApiUrl : cafm.getClientSettings().baseUrl;
        // ensure starting slash
        if (!path.startsWith('/') && !path.startsWith('http') && !burl.endsWith('/')) path = '/' + path;
        // ensure ending slash
        //if (!path.endsWith('/')) path += '/';
        // ensure base path is not prepended, when base path is included in the path arg
        return !path.startsWith(burl) ? (burl + path) : path;
    },
    getLocation: function (absoluteUrl) {
        var l = document.createElement("a");
        l.href = absoluteUrl;
        return l;
    },
    addQueryParam: function (path,pName,pVal)
    {
        pName = encodeURIComponent(pName);
        pVal = encodeURIComponent(pVal);

        if (path.indexOf('?') > -1) {
            return path.concat("&", pName, "=", pVal);
        } else {
            return path.concat("?", pName, "=", pVal);
        }
    }
}